import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";

// Reactstrap components
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import Form from "reactstrap/lib/Form";
import ModalHeader from "reactstrap/lib/ModalHeader";
import moment from "moment";

import ProgressBar from "components/ProgressBar/StepperProgress";

// leaflet
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";

// style
import "assets/css/map.css";
import {
  table_translate,
  table_style,
} from "../../../constants/MaterialTable.js";

// helpers
import { formateDateandTime } from "../../../helpers/formats";

// services
import { api_GET } from "../../../services/api_service.js";
import { showMessage } from "../../../services/message.js";

// views
import AcoesGestor from "../../../views/Shared/AcoesGestor";
import { api_POST } from "../../../services/api_service";

//Context
import { useAuth } from "../../../context/auth";

export default function FichaRequerimento({
  item,
  handleReturn,
  showAcoesGestor,
}) {
  const { session, setupSistema } = useAuth();

  const [requerimento, set_requerimento] = useState(null);

  const [stepAtual, set_stepAtual] = useState(0);
  const [steps, set_steps] = useState([]);

  // pegar as justificativas feitas no protocolo na tela de manutenção
  const [justificativaList, setJustificativaList] = React.useState([]);

  const [isLoadingEmitirGuia, setIsLoadingEmitirGuia] = React.useState(false);

  const [modal, setModal] = React.useState(false);

  const toggleModal = () => setModal(!modal);

  //State para modal do contrato
  const [modalContrato, set_modalContrato] = useState(false);

  //State Para adicionar os contratos em cada local
  const [listContratoLocal, set_listcontratoLocal] = useState([]);

  const toggleModalContrato = () => set_modalContrato(!modalContrato);

  const laodJustificativasProtocolo = () => {
    api_GET(
      `protocolo/GetJustificativaManuntecaoProtocolo/${item.protocolo_Id}`
    )
      .then((result) => setJustificativaList(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null));
  };

  // Mapa
  const [modalMapaOpen, set_modalMapaOpen] = useState(false);
  const [centerMap, setCenterMap] = useState([0, 0]);
  const [positionMarker, setpositionMarker] = useState([0, 0]);
  const iconMarker = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
    iconRetinaUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
  });
  const ChangeMap = ({ center, zoom }) => {
    const mapInstance = useMap();
    mapInstance.setView(center, zoom);
    return null;
  };
  const handleModalOpen = (geoLocalizacao) => {
    if (geoLocalizacao && geoLocalizacao.split(";").length > 1) {
      setCenterMap([
        geoLocalizacao.split(";")[0],
        geoLocalizacao.split(";")[1],
      ]);
      setpositionMarker([
        geoLocalizacao.split(";")[0],
        geoLocalizacao.split(";")[1],
      ]);
      set_modalMapaOpen(true);
    }
  };

  const [existAcaoDocumento, setExistAcaoDocumento] = useState(null);
  const loadItem = () => {
    //verifica se a ação teve o step de documento
    api_GET("setupSolicitacao/GetByAcaoId/" + item.setupSolicitacaoAcao_Id)
      .then((result) =>
        setExistAcaoDocumento(
          result.data.solicitacaoAcoes.filter(
            (f) => f.setupSolicitacaoAcao_Id == item.setupSolicitacaoAcao_Id
          )[0].acaoDocumentos.length
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null));

    if (item.etapaCadastro == 0 && existAcaoDocumento > 0) {
      showMessage(
        "Aviso",
        "No momento não é possivel visualizar os dados em andamento, porque o Requerimento ainda não passou da tela de identificação.",
        "warning",
        null
      );
      handleReturn();
    }

    set_requerimento(item);

    if (item.fluxoCadastroEtapaAtual != null)
      set_stepAtual(item.fluxoCadastroEtapaAtual.ordem - 1);
  };

  const openGuiaCobranca = (rowData) => {
    const arquivoPDF = rowData.logCobrancas.filter(
      (l) => l.nomeArquivo != null
    );
    const linkSource = `data:application/pdf;base64,${arquivoPDF[0].nomeArquivo}`;
    const downloadLink = document.createElement("a");
    const fileName = requerimento.numeroRequerimento + ".pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const openArquivoContrata = (rowData) => {
    const linkSource = `data:application/pdf;base64,${rowData.arquivoContrato}`;
    const downloadLink = document.createElement("a");
    const fileName = "ContratoLocal.pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const loadSteps = () => {
    api_GET(
      "FluxoCadastro/BySetupSolicitacaoAcaoId/" + item.setupSolicitacaoAcao_Id
    )
      .then((result) => {
        if (result.data != null) {
          let etapas = [];
          result.data.fluxoCadastroEtapas
            .sort(function (a, b) {
              return a.ordem - b.ordem;
            })
            .map((m) => {
              etapas.push(m.tipo);
            });
          set_steps(etapas);
        }
      })
      .catch((err) => showMessage("Aviso", err.message, "error", null));
  };

  const [historicoAnaliseGestor, set_historicoAnaliseGestor] = useState([]);
  const loadHistoricoAnaliseGestor = () => {
    api_GET(
      "requerimento/GetHistoricoAprovacaoRequerimento/" + item.requerimento_Id
    )
      .then((result) => set_historicoAnaliseGestor(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null));
  };

  useEffect(() => {
    loadItem();
    loadSteps();
    loadHistoricoAnaliseGestor();
    laodJustificativasProtocolo();
  }, []);

  const handleEmitirGuia = () => {
    let json_submit = {
      requerimento_Id: requerimento.requerimento_Id,
    };

    setIsLoadingEmitirGuia(true);
    api_POST("AnaliseRequerimento/PostRequerimentoCobranca", json_submit)
      .then((result) =>
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          window.location.reload()
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null));
  };

  return (
    <>
      <Modal isOpen={modal} toggle={toggleModal} size={"lg"}>
        <ModalHeader toggle={toggleModal}>
          Histórico de Justificativas na tela de manunteção.
        </ModalHeader>
        <ModalBody>
          <Form>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col" className="">
                      Data da Justificativa
                    </th>
                    <th scope="col">Observação</th>
                    <th scope="col">Usuário</th>
                  </tr>
                </thead>
                <tbody>
                  {justificativaList.length > 0 &&
                    justificativaList.map((justificativa, index) => (
                      <tr key={index}>
                        <td>
                          {formateDateandTime(justificativa.dataJustificativa)}
                        </td>
                        <td>{justificativa.observacao}</td>
                        <td>{justificativa.nome ?? ""}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            OK
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        centered
        isOpen={modalContrato}
        toggle={toggleModalContrato}
        size={"xl"}
        style={{ marginTop: "70px" }}
      >
        <ModalBody className="md-bd">
          <ModalHeader
            toggle={toggleModalContrato}
            className="p-0 mb-2"
            style={{ borderBottom: "none" }}
            close={<></>}
          >
            Contratos
          </ModalHeader>
          <Row>
            <Col md="12">
              <MaterialTable
                style={{ minHeight: "auto" }}
                title={""}
                columns={[
                  { title: "Modalidade", field: "modalidadeColeta" },
                  { title: "CNPJ", field: "transportador_CNPJ" },
                  { title: "Razão Social", field: "transportador_RazaoSocial" },
                ]}
                data={listContratoLocal}
                actions={[
                  {
                    icon: "download",
                    tooltip: "Fazer download",
                    onClick: (event, rowData) =>
                      window.open(
                        setupSistema?.caminhoVirtual + rowData.arquivoContrato,
                        "_blank"
                      ),
                  },
                ]}
                isLoading={false}
                localization={table_translate}
                options={table_style}
              />
            </Col>
          </Row>
          <Row>
            <Col md="12" className="d-flex justify-content-center">
              <Button
                className="text-center"
                color={"dark"}
                onClick={toggleModalContrato}
              >
                Fechar
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {isLoadingEmitirGuia && (
        <div className="carregandoCmp">
          <div className="box">
            <img src={require("assets/img/loading.gif")}></img>
          </div>
        </div>
      )}
      {!isLoadingEmitirGuia && requerimento != null && (
        <div>
          <Container className="text-center">
            <ProgressBar stepValue={stepAtual} steps={steps} />
          </Container>
          {handleReturn != null && (
            <Button color="secondary" onClick={handleReturn}>
              <i class="fas fa-chevron-left"></i> VOLTAR
            </Button>
          )}
          <Card className={`card-stats`}>
            <CardBody>
              <Row>
                <Col lg="12">
                  <h2 className="titulo-solicitacao text-center">
                    {
                      requerimento.setupSolicitacaoAcao.setupSolicitacao
                        .categoria.descricao
                    }
                  </h2>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Empresa</h3>
                  <div className="line-protocolo"></div>
                </Col>
              </Row>
              <Row>
                <Col lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].nome_Fantasia
                      : requerimento.protocolo.protocoloGerador[0]
                        .nome_Fantasia}
                  </h6>
                </Col>
                <Col className="text-mobile" lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>{requerimento.cpf_Cnpj}</h6>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Razão Social:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].razaoSocial
                      : requerimento.protocolo.protocoloGerador[0].razaoSocial}
                  </p>
                </Col>
                <Col lg="2" sm="12">
                  <p>
                    <b>CCM:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].ccm
                      : requerimento.protocolo.protocoloGerador[0].ccm}
                  </p>
                </Col>
                <Col lg="4" sm="12">
                  <p>
                    <b>Código Cadastro:</b>{" "}
                    {item.protocolo.codigoCadastro != null
                      ? item.protocolo.codigoCadastro
                      : ""}
                  </p>
                </Col> <Col lg="4" sm="12">
                  <p>
                    <b>Ramo:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0 &&
                      requerimento.requerimentoGerador[0].ramoAtividade != null
                      ? requerimento.requerimentoGerador[0].ramoAtividade
                      : requerimento.protocolo.protocoloGerador[0]
                        .ramoAtividade}
                  </p>
                </Col>
                <Col lg="4" sm="12">
                  <p>
                    <b>Tipo de Indústria / Coméricio:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0 &&
                      requerimento.requerimentoGerador[0].tipoIndustriaComercio !=
                      null
                      ? requerimento.requerimentoGerador[0]
                        .tipoIndustriaComercio
                      : requerimento.protocolo.protocoloGerador[0]
                        .tipoIndustriaComercio}
                  </p>
                </Col>
                <Col lg="2" sm="12">
                  <p>
                    <b>CEP:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].cep
                      : requerimento.protocolo.protocoloGerador[0].cep}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Endereço:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].logradouro +
                      ", " +
                      requerimento.requerimentoGerador[0].numEndereco +
                      ", " +
                      requerimento.requerimentoGerador[0].complemento
                      : requerimento.protocolo.protocoloGerador[0].logradouro +
                      ", " +
                      requerimento.protocolo.protocoloGerador[0].numEndereco}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Bairro:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].bairro
                      : requerimento.protocolo.protocoloGerador[0].bairro}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Cidade:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].cidade
                      : requerimento.protocolo.protocoloGerador[0].cidade}
                  </p>
                </Col>
                {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria
                  .sigla == "RSS" && (
                    <Col lg="12" sm="12">
                      <p>
                        <b>Tipo Estabelecimento:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0 &&
                          requerimento.requerimentoGerador[0].tipoEstabelecimento !=
                          null
                          ? requerimento.requerimentoGerador[0]
                            .tipoEstabelecimento.descricao
                          : requerimento.protocolo.protocoloGerador[0]
                            .tipoEstabelecimento == null
                            ? ""
                            : requerimento.protocolo.protocoloGerador[0]
                              .tipoEstabelecimento.descricao}
                      </p>
                    </Col>
                  )}
                {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria
                  .sigla == "RSS" &&
                  requerimento.requerimentoGerador.length > 0 &&
                  requerimento.requerimentoGerador[0].tipoEstabelecimento !=
                  null &&
                  requerimento.requerimentoGerador[0].tipoEstabelecimento
                    .descricao == "HOSPITAL" && (
                    <Col lg="6" sm="12">
                      <p>
                        <b>Quantidade Leitos Ativos:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0 &&
                          requerimento.requerimentoGerador[0]
                            .quantidadeLeitosAtivos != null
                          ? requerimento.requerimentoGerador[0]
                            .quantidadeLeitosAtivos
                          : requerimento.protocolo.protocoloGerador[0]
                            .quantidadeLeitosAtivos}
                      </p>
                    </Col>
                  )}
                {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria
                  .sigla == "RSS" &&
                  requerimento.requerimentoGerador.length > 0 &&
                  requerimento.requerimentoGerador[0].tipoEstabelecimento !=
                  null &&
                  requerimento.requerimentoGerador[0].tipoEstabelecimento
                    .descricao == "HOSPITAL" && (
                    <Col lg="6" sm="12">
                      <p>
                        <b>Quantidade Leitos Inativos:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0 &&
                          requerimento.requerimentoGerador[0]
                            .quantidadeLeitosInativos != null
                          ? requerimento.requerimentoGerador[0]
                            .quantidadeLeitosInativos
                          : requerimento.protocolo.protocoloGerador[0]
                            .quantidadeLeitosInativos}
                      </p>
                    </Col>
                  )}
                {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria
                  .sigla == "RSS" && (
                    <Col lg="12" sm="12">
                      <p>
                        <b>Classificação Estabelecimento:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0 &&
                          requerimento.requerimentoGerador[0]
                            .classificacaoEstabelecimento != null
                          ? requerimento.requerimentoGerador[0]
                            .classificacaoEstabelecimento.descricao
                          : requerimento.protocolo.protocoloGerador[0]
                            .classificacaoEstabelecimento == null
                            ? ""
                            : requerimento.protocolo.protocoloGerador[0]
                              .classificacaoEstabelecimento.descricao}
                      </p>
                    </Col>
                  )}
                <Col lg="12" sm="12">
                  {session != null &&
                    session.tipoAcesso == "AreaRestrita" &&
                    session.usuario_Id != null &&
                    justificativaList.length > 0 && (
                      <div className="d-flex align-items-center justify-content-center">
                        <Button
                          color="link"
                          className="text-end"
                          onClick={() => setModal(true)}
                        >
                          <i className="fas fa-file-alt mr-2"></i>
                          Observações do Cadastro
                        </Button>
                      </div>
                    )}
                </Col>
              </Row>

              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Responsável</h3>
                  <div className="line-protocolo"></div>
                </Col>
              </Row>

              <Row>
                <Col lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].nomeResponsavel
                      : requerimento.protocolo.protocoloGerador[0]
                        .nomeResponsavel}
                  </h6>
                </Col>
                <Col className="text-mobile" lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>{requerimento.email}</h6>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Telefone:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].telefone
                      : requerimento.protocolo.protocoloGerador[0].telefone}
                  </p>
                </Col>
                <Col lg="6" className="text-mobile" sm="12">
                  <p>
                    <b>Celular:</b>{" "}
                    {requerimento.requerimentoGerador.length > 0
                      ? requerimento.requerimentoGerador[0].celular
                      : requerimento.protocolo.protocoloGerador[0].celular}
                  </p>
                </Col>
              </Row>

              {requerimento.setupSolicitacaoAcao.setupSolicitacao.categoria
                .sigla == "RSS" && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">Responsável Técnico</h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" sm="12">
                        <h6 style={{ paddingTop: "5px" }}>
                          {requerimento.requerimentoGerador.length > 0
                            ? requerimento.requerimentoGerador[0]
                              .nomeResponsavelTecnico
                            : requerimento.protocolo.protocoloGerador[0]
                              .nomeResponsavelTecnico}
                        </h6>
                      </Col>
                      <Col lg="4" sm="12">
                        <p>
                          <b>Tipo Documento:</b>{" "}
                          {requerimento.requerimentoGerador.length > 0
                            ? requerimento.requerimentoGerador[0]
                              .tipoDocumentoResponsavelTecnico
                            : requerimento.protocolo.protocoloGerador[0]
                              .tipoDocumentoResponsavelTecnico}
                        </p>
                      </Col>
                      <Col lg="4" sm="12">
                        <p>
                          <b>Número Documento:</b>{" "}
                          {requerimento.requerimentoGerador.length > 0
                            ? requerimento.requerimentoGerador[0]
                              .numeroDocumentoResponsavelTecnico
                            : requerimento.protocolo.protocoloGerador[0]
                              .numeroDocumentoResponsavelTecnico}
                        </p>
                      </Col>
                      <Col lg="4" sm="12">
                        {requerimento.requerimentoGerador.length > 0 &&
                          requerimento.requerimentoGerador[0]
                            .arquivoCertificadoResponsavelTecnico != null ? (
                          <a
                            href={
                              setupSistema?.caminhoVirtual +
                              requerimento.requerimentoGerador[0]
                                .arquivoCertificadoResponsavelTecnico
                            }
                            target="_blank"
                          >
                            Certificado Curso
                          </a>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </>
                )}

              {requerimento != null &&
                requerimento.setupSolicitacaoAcao.setupSolicitacao
                  .categoria.segmento === "Grande Gerador - PGRCC" && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Responsável Técnico Pelo Projeto</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>CPF do Responsável:</b>{" "}
                        {requerimento.requerimentoGerador[0]?.cpfResponsavel ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Função do Reponsável:</b>{" "}
                        {requerimento.requerimentoGerador[0]?.funcaoResponsavel ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Departamento do Reponsável:</b>{" "}
                        {requerimento.requerimentoGerador[0]?.departamentoResponsavel ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Código CNAE:</b>{" "}
                        {requerimento.requerimentoGerador[0]?.codigoCNAE ??
                          ""}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Atividade CNA:</b>{" "}
                        {requerimento.requerimentoGerador[0]?.atividadeCNA ??
                          ""}
                      </p>
                    </Col>
                  </Row>
                )
              }

              {/* Grande Gerador - PGRCC */}
              {requerimento?.requerimentoGerador[0] &&
                requerimento?.requerimentoGerador[0]?.requerimentoGeradorObras
                  ?.length > 0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">Dados da Obra</h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Razão Social:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.razaoSocial
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Nome Fantasia:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.fantasia
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CNPJ:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.cnpj
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Telefone:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.telefone
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Email:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.email
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Contato:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.contato
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CEP:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.cep
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Logradouro:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.logradouro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Número:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.numero
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Complemento:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.complemento
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Bairro:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.bairro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Cidade:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.cidade
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>UF:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.uf
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Área Construir:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.areaConstruir
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Área Demolir:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.areaDemolir
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Volume Receber:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.volumeReceber
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Volume Destinar:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.volumeDestinar
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Tipo Empreendimento:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.tipoEmpreendimento
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Tipo Construção:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.tipoConstrucao
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Tipologia:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.tipologia
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Práticas de Reciclagem:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]
                            ?.praticasDeReciclagem
                        }
                      </Col>
                      <Col lg="12" className="mb-2">
                        <b>Descrição do Empreendimento:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]
                            ?.descricaoEmpreendimento
                        }
                      </Col>
                      <Col lg="12" className="mb-2">
                        <b>Outras Informações:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorObras?.[0]?.outrasInformacoes
                        }
                      </Col>
                    </Row>
                  </>
                )}

              {requerimento?.requerimentoGerador[0] &&
                requerimento?.requerimentoGerador[0]
                  ?.requerimentoGeradorExecutorObras?.length > 0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">
                          Dados do Executor da Obra
                        </h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CPF/CNPJ:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.cpf_Cnpj
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Razão Social:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.razaoSocial
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Nome Fantasia:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.fantasia
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Telefone:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.telefone
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Email:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.email
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>Representante Legal:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.representanteLegal
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CPF Representante:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.cpfRepresentante
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Função Representante:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.funcaoRepresentante
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Departamento Representante:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.departamentoRepresentante
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>Código CNAE:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.codigoCNAE
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Atividade CNA:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.atividadeCNA
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>CEP:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.cep
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Logradouro:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.logradouro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Número:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.numero
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Complemento:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.complemento
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Bairro:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.bairro
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Cidade:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.cidade
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>UF:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]?.uf
                        }
                      </Col>

                      <Col lg="6" sm="12" className="mb-2">
                        <b>Nome Responsável Técnico:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.nomeResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CPF Responsável Técnico:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.cpfResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>CREA Responsável Técnico:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.creaResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Função Responsável Técnico:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.funcaoResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Departamento Responsável Técnico:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.departamentoResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Telefone Responsável Técnico:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.telefoneResponsavelTecnico
                        }
                      </Col>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Email Responsável Técnico:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorExecutorObras?.[0]
                            ?.emailResponsavelTecnico
                        }
                      </Col>
                    </Row>
                  </>
                )}

              {requerimento?.requerimentoGerador?.[0] &&
                requerimento?.requerimentoGerador?.[0]
                  ?.requerimentoGeradorModeloPlanoResiduos?.length > 0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">
                          Modelo do Plano Resíduo
                        </h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6" sm="12" className="mb-2">
                        <b>Modelo:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                            ?.modelo
                        }
                      </Col>
                      <Col lg="12" className="mb-2">
                        <b>Descrição:</b>{" "}
                        {
                          requerimento?.requerimentoGerador?.[0]
                            ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                            ?.descricao
                        }
                      </Col>
                      {requerimento?.requerimentoGerador?.[0]
                        ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                        ?.preExecucaoDe && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pré Execução De:</b>{" "}
                            {new Date(
                              requerimento.requerimentoGerador[0].requerimentoGeradorModeloPlanoResiduos[0].preExecucaoDe
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {requerimento?.requerimentoGerador?.[0]
                        ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                        ?.preExecucaoAte && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pré Execução Até:</b>{" "}
                            {new Date(
                              requerimento.requerimentoGerador[0].requerimentoGeradorModeloPlanoResiduos[0].preExecucaoAte
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {requerimento?.requerimentoGerador?.[0]
                        ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                        ?.execucaoDe && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Execução De:</b>{" "}
                            {new Date(
                              requerimento.requerimentoGerador[0].requerimentoGeradorModeloPlanoResiduos[0].execucaoDe
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {requerimento?.requerimentoGerador?.[0]
                        ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                        ?.execucaoAte && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Execução Até:</b>{" "}
                            {new Date(
                              requerimento.requerimentoGerador[0].requerimentoGeradorModeloPlanoResiduos[0].execucaoAte
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {requerimento?.requerimentoGerador?.[0]
                        ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                        ?.posExecucaoDe && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pós Execução De:</b>{" "}
                            {new Date(
                              requerimento.requerimentoGerador[0].requerimentoGeradorModeloPlanoResiduos[0].posExecucaoDe
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                      {requerimento?.requerimentoGerador?.[0]
                        ?.requerimentoGeradorModeloPlanoResiduos?.[0]
                        ?.posExecucaoAte && (
                          <Col lg="6" sm="12" className="mb-2">
                            <b>Pós Execução Até:</b>{" "}
                            {new Date(
                              requerimento.requerimentoGerador[0].requerimentoGeradorModeloPlanoResiduos[0].posExecucaoAte
                            ).toLocaleDateString("pt-BR")}
                          </Col>
                        )}
                    </Row>
                  </>
                )}

              {requerimento?.requerimentoGerador?.[0] &&
                requerimento?.requerimentoGerador?.[0]
                  ?.requerimentoGeradorDetalhamentoPlanoResiduos?.length >
                0 && (
                  <>
                    <Row>
                      <Col lg="12">
                        <h3 className="titulo-consulta">
                          Detalhamento do Plano Resíduo
                        </h3>
                        <div className="line-protocolo"></div>
                      </Col>
                    </Row>
                    <MaterialTable
                      style={{ minHeight: "auto", width: "100%" }}
                      title=""
                      columns={[
                        { title: "Fase", field: "fase" },
                        { title: "Detalhamento", field: "detalhamento" },
                        {
                          title: "Descrição",
                          field: "descricao",
                        },
                        { title: "Volume por Mês (m³)", field: "volumeMes" },
                        {
                          title: "Armazenamento na Obra",
                          field: "armazenamentoObra",
                        },
                        {
                          title: "Tipo de Destinação",
                          field: "tipoDestinacao",
                        },
                      ]}
                      data={
                        requerimento?.requerimentoGerador[0]
                          .requerimentoGeradorDetalhamentoPlanoResiduos
                      }
                      isLoading={false}
                      options={{
                        filtering: false,
                        exportButton: true,
                      }}
                      localization={table_translate}
                    />
                  </>
                )}

              {requerimento?.requerimentoGerador?.[0] &&
                requerimento?.requerimentoGerador?.[0]
                  ?.requerimentoGeradorDestinosPGRCC?.length > 0 && (
                  <>
                    <Row className="mt-4">
                      <Col lg="12">
                        <h3 className="titulo-consulta">Destinos</h3>
                        <div className="line-protocolo"></div>
                      </Col>

                      <MaterialTable
                        style={{ minHeight: "auto", width: "100%" }}
                        title=""
                        columns={[
                          { title: "CNPJ do Destino", field: "cnpjDestino" },
                          { title: "Fantasia", field: "nomeFantasiaDestino" },
                          { title: "Razão Social", field: "razaoSocialDestino" },
                        ]}
                        data={
                          requerimento?.requerimentoGerador[0]
                            .requerimentoGeradorDestinosPGRCC
                        }
                        isLoading={false}
                        options={{
                          filtering: false,
                          exportButton: true,
                        }}
                        localization={table_translate}
                      />
                    </Row>
                  </>
                )}

              {requerimento?.requerimentoGerador?.[0] &&
                requerimento?.requerimentoGerador?.[0]
                  ?.requerimentoGeradorTransportadoresPGRCC?.length > 0 && (
                  <>
                    <Row className="mt-4">
                      <Col lg="12">
                        <h3 className="titulo-consulta">Transportadores</h3>
                        <div className="line-protocolo"></div>
                      </Col>

                      <MaterialTable
                        style={{ minHeight: "auto", width: "100%" }}
                        title=""
                        columns={[
                          { title: "CNPJ do Transportador", field: "cnpjTransportador", },
                          { title: "Fantasia", field: "nomeFantasiaTransportador", },
                          { title: "Razão Social", field: "razaoSocialTransportador", },
                        ]}
                        data={
                          requerimento?.requerimentoGerador[0]
                            .requerimentoGeradorTransportadoresPGRCC
                        }
                        isLoading={false}
                        options={{
                          filtering: false,
                          exportButton: true,
                        }}
                        localization={table_translate}
                      />
                    </Row>
                  </>
                )}

              {/* ----------------------- */}

              {requerimento?.setupSolicitacaoAcao?.setupSolicitacao?.categoria
                .sigla === "RGG" &&
                requerimento?.setupSolicitacaoAcao?.setupSolicitacao?.categoria
                  .segmento === "Grande Gerador" && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Dados Adicionais</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Número de Colaboradores:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0
                          ? requerimento.requerimentoGerador[0]
                            .numeroColaboradores
                          : requerimento.protocolo.protocoloGerador[0]
                            .numeroColaboradores}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Consumo mensal de Energia:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0
                          ? requerimento.requerimentoGerador[0]
                            .consumoMensalAgua
                          : requerimento.protocolo.protocoloGerador[0]
                            .consumoMensalAgua}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Consumo Mensal de Água:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0
                          ? requerimento.requerimentoGerador[0]
                            .consumoMensalAgua
                          : requerimento.protocolo.protocoloGerador[0]
                            .consumoMensalAgua}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Local do Empreendimento:</b>{" "}
                        {requerimento.requerimentoGerador.length > 0
                          ? requerimento.requerimentoGerador[0]
                            .localEmpreendimento
                          : requerimento.protocolo.protocoloGerador[0]
                            .localEmpreendimento}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Área total (m²):</b>{" "}
                        {requerimento.requerimentoGerador.length > 0
                          ? requerimento.requerimentoGerador[0]?.areaTotal
                            ?.toString()
                            .replace(".", ",")
                          : requerimento.protocolo.protocoloGerador[0].areaTotal
                            ?.toString()
                            .replace(".", ",")}
                      </p>
                    </Col>
                    <Col lg="6" sm="12">
                      <p>
                        <b>Área Construída (m²):</b>{" "}
                        {requerimento.requerimentoGerador.length > 0
                          ? requerimento.requerimentoGerador[0].areaConstruida
                            ?.toString()
                            .replace(".", ",")
                          : requerimento.protocolo.protocoloGerador[0].areaConstruida
                            ?.toString()
                            .replace(".", ",")}
                      </p>
                    </Col>
                  </Row>
                )}

              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Requerimento</h3>
                  <div className="line-protocolo"></div>
                </Col>
              </Row>
              <Row lg="4">
                <Col>
                  <b>Tipo:</b> <p>{requerimento.setupSolicitacaoAcao.acao}</p>
                </Col>
                <Col>
                  <b>Número :</b> <p>{requerimento.numeroRequerimento}</p>
                </Col>
                <Col>
                  <b>Data Solicitação: </b>{" "}
                  <p>
                    {formateDateandTime(requerimento.dataCriacaoRequerimento)}
                  </p>
                </Col>
                <Col>
                  <b>Data Atualização: </b>{" "}
                  <p>{formateDateandTime(requerimento.dataUltimaAcao)}</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <b>Status: </b> <p>{requerimento.status}</p>
                </Col>
                {requerimento.status == "Divergente" && (
                  <Col>
                    <b>Divergência: </b>{" "}
                    <p>
                      {
                        requerimento.requerimentoAnaliseGestor.sort(function (
                          a,
                          b
                        ) {
                          return (
                            new Date(b.dataAnalise) - new Date(a.dataAnalise)
                          );
                        })[0].observacao
                      }
                    </p>
                  </Col>
                )}
              </Row>
              {requerimento.requerimentoMotivoCancelamento.length > 0 && (
                <Row>
                  <Col lg="12">
                    <h3 className="titulo-consulta">Motivo do Cancelamento</h3>
                    <div className="line-protocolo"></div>
                  </Col>
                  <Col md="12">
                    <p>
                      {requerimento.requerimentoMotivoCancelamento[0].motivo}
                    </p>
                  </Col>
                </Row>
              )}
              {requerimento.requerimentoGeradorCaracterizacaoResiduo != null &&
                requerimento.requerimentoGeradorCaracterizacaoResiduo.length >
                0 && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">
                        Caracterização dos Resíduos
                      </h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="12">
                      <Row md="12">
                        <Col md="1">
                          <b>Grupo</b>
                        </Col>
                        <Col
                          md={
                            requerimento.requerimentoGeradorCaracterizacaoResiduo.filter(
                              (x) => !!x.caracterizacaoResiduosConama.grupo
                            ).length > 0
                              ? "1"
                              : "2"
                          }
                        >
                          <b>Código</b>
                        </Col>
                        <Col md="1">
                          <b>Tipo</b>
                        </Col>
                        <Col md="7">
                          <b>Descrição</b>
                        </Col>
                        <Col md="2">
                          <b>Quantidade</b>
                        </Col>
                      </Row>
                      {requerimento.requerimentoGeradorCaracterizacaoResiduo.map(
                        (item, key) => (
                          <div key={key}>
                            <Row md="12">
                              <Col md="1">
                                <p>
                                  {item.caracterizacaoResiduosConama.grupo ??
                                    ""}
                                </p>
                              </Col>
                              <Col
                                md={
                                  !!item.caracterizacaoResiduosConama.grupo
                                    ? "1"
                                    : "2"
                                }
                              >
                                <p>
                                  {item.caracterizacaoResiduosConama.codigo ??
                                    ""}
                                </p>
                              </Col>
                              <Col md="1">
                                <p>
                                  {item.caracterizacaoResiduosConama.tipo ?? ""}
                                </p>
                              </Col>
                              <Col md="7">
                                <p>
                                  {item.caracterizacaoResiduosConama.descricao}
                                </p>
                              </Col>
                              <Col md="2">
                                <p>
                                  {item.quantidadeEstimada}{" "}
                                  {requerimento.setupSolicitacaoAcao
                                    ?.setupSolicitacao?.categoria?.sigla ==
                                    "RSS"
                                    ? "Kg/dia"
                                    : "Litros/dia"}{" "}
                                </p>
                              </Col>
                            </Row>
                            <hr />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                )}

              {requerimento.requerimentoGeradorLocalArmazenagem != null &&
                requerimento.requerimentoGeradorLocalArmazenagem.length > 0 && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Locais de Armazenagem</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="12">
                      {requerimento.requerimentoGeradorLocalArmazenagem.map(
                        (item, key) => (
                          <div key={key}>
                            <Row md="12">
                              <Col md="2">
                                <b>CEP:</b> <p>{item.cep}</p>
                              </Col>
                              <Col md="4">
                                <b>Endereço:</b>{" "}
                                <p>
                                  {item.logradouro + ", " + item.numEndereco}
                                </p>
                              </Col>
                              <Col md="4">
                                <b>Bairro:</b> <p>{item.bairro}</p>
                              </Col>
                              <Col md="2">
                                <Button
                                  color="info"
                                  type="button"
                                  onClick={() =>
                                    handleModalOpen(item.geoLocalizacao)
                                  }
                                >
                                  <i className="fas fa-map-marked-alt"></i>
                                </Button>
                              </Col>
                            </Row>
                            <hr />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                )}

              {requerimento.requerimentoGeradorLocal != null &&
                requerimento.requerimentoGeradorLocal.length > 0 && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Locais de Coleta</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="12">
                      {requerimento.requerimentoGeradorLocal.map(
                        (item, key) => (
                          <div key={key}>
                            <Row md="12">
                              <Col md="2">
                                <b>CEP:</b> <p>{item.cep}</p>
                              </Col>
                              <Col md="4">
                                <b>Endereço:</b>{" "}
                                <p>
                                  {item.logradouro + ", " + item.numEndereco}
                                </p>
                              </Col>
                              <Col md="3">
                                <b>Bairro:</b> <p>{item.bairro}</p>
                              </Col>
                              <Col md="3">
                                {item.geoLocalizacao != null && (
                                  <Button
                                    color="info"
                                    type="button"
                                    onClick={() =>
                                      handleModalOpen(item.geoLocalizacao)
                                    }
                                  >
                                    <i className="fas fa-map-marked-alt"></i>
                                  </Button>
                                )}

                                {item?.requerimentoGeradorLocalContratos
                                  ?.length > 0 && (
                                    <Button
                                      color="success"
                                      type="button"
                                      onClick={() => {
                                        set_listcontratoLocal(
                                          item?.requerimentoGeradorLocalContratos
                                        );
                                        set_modalContrato(true);
                                      }}
                                    >
                                      <i className="fas fa-file-alt"></i>{" "}
                                      Contratos
                                    </Button>
                                  )}
                              </Col>
                            </Row>
                            <hr />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                )}

              {requerimento.requerimentoGerador != null &&
                requerimento.requerimentoGerador.length > 0 &&
                requerimento.requerimentoGerador[0]
                  .requerimentoGeradorClasseResiduo != null &&
                requerimento.requerimentoGerador[0]
                  .requerimentoGeradorClasseResiduo.length > 0 && (
                  <Row>
                    <Col lg="12">
                      <h3 className="titulo-consulta">Classes de Resíduo</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="12">
                      {requerimento.requerimentoGerador[0].requerimentoGeradorClasseResiduo.map(
                        (item, key) => (
                          <div key={key}>
                            <Row md="12">
                              <Col md="6">
                                <b>Classe:</b>{" "}
                                <p>{item.classeResiduo.descricao}</p>
                              </Col>
                              <Col md="6">
                                <b>Quantidade Estimada (Kg):</b>{" "}
                                <p>{item.quantidadeEstimada}</p>
                              </Col>
                            </Row>
                            <hr />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                )}

              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Documentos</h3>
                  <div className="line-protocolo"></div>
                </Col>

                <MaterialTable
                  style={{ minHeight: "auto", width: "100%" }}
                  title=""
                  columns={[
                    { title: "Documento", field: "documento.descricao" },
                    { title: "Arquivo", field: "arquivo" },
                    { title: "Status Análise", field: "statusAnalise" },
                    { title: "Motivo Reprova", field: "motivoReprovaAnalise" },
                  ]}
                  data={requerimento.requerimentoDocumento}
                  isLoading={false}
                  actions={[
                    {
                      icon: "insert_drive_file",
                      tooltip: "Visualizar Documento",
                      onClick: (event, rowData) =>
                        window.open(
                          setupSistema?.caminhoVirtual + rowData.arquivo,
                          "_blank"
                        ),
                    },
                  ]}
                  localization={table_translate}
                  options={table_style}
                />
              </Row>

              {!!requerimento?.requerimentoTaxaFislurb &&
                requerimento?.requerimentoTaxaFislurb.length > 0 && <Row>
                  <div className="col-12 col-lg-12">
                    <h3 className="titulo-consulta">Identificação Taxa FisLurb</h3>
                    <div className="line-protocolo"></div>
                  </div>

                  <div className="col-12 col-lg-12">
                    <div className="row">
                      <div className="col-2 col-lg-2">
                        <b>Tipo de Empresa</b> <p>{requerimento?.requerimentoTaxaFislurb[0]?.tipoEmpresa}</p>
                      </div>
                      <div className="col-2 col-lg-2">
                        <b>Faixa de Valores:</b> <p>{requerimento?.requerimentoTaxaFislurb[0]?.faixaValores}</p>
                      </div>
                    </div>
                  </div>

                  <Col lg="12" className="mt-2">
                    <h3 className="titulo-consulta">Anexos Taxa FisLurb</h3>
                    <div className="line-protocolo"></div>
                  </Col>

                  <MaterialTable
                    style={{ minHeight: "auto", width: "100%" }}
                    title=""
                    columns={[
                      { title: "Arquivo", field: "guiaArrecadacao" },
                      {
                        title: "Data Pagamento",
                        field: "dataPagamento",
                        render: rowData =>
                          rowData.dataPagamento
                            ? moment(rowData.dataPagamento).format("DD/MM/YYYY")
                            : "",
                      },
                      {
                        title: "Usuário Confirmação Pagamento",
                        field: "usuarioConfirmacaoPagamento",
                        render: rowData =>
                          rowData?.usuario
                            ? rowData?.usuario?.nome
                            : "",
                      },
                    ]}
                    data={requerimento?.requerimentoTaxaFislurb[0].requerimentoTaxaFislurbBoletos}
                    isLoading={false}
                    actions={[
                      {
                        icon: "insert_drive_file",
                        tooltip: "Visualizar Documento",
                        onClick: (event, rowData) =>
                          window.open(
                            setupSistema?.caminhoVirtual + rowData.guiaArrecadacao,
                            "_blank"
                          ),
                      },
                    ]}
                    localization={table_translate}
                    options={table_style}
                  />
                </Row>}

              {session != null &&
                session.tipoAcesso == "AreaRestrita" &&
                requerimento &&
                !!requerimento?.observacaoRequerente && (
                  <Row className="mt-4">
                    <Col lg="12">
                      <h3 className="titulo-consulta">
                        Observações do Requerente
                      </h3>
                      <div className="line-protocolo"></div>
                    </Col>

                    <Col lg="12" className="mt-2">
                      <p>{requerimento?.observacaoRequerente}</p>
                    </Col>
                  </Row>
                )}

              {setupSistema &&
                setupSistema.metodologiaCobranca == "Integração PRODAM" &&
                requerimento.requerimentoCobrancas.length > 0 && (
                  <Row className="row mt-4">
                    <Col lg="12">
                      <h3 className="titulo-consulta">Cobranças</h3>
                      <div className="line-protocolo"></div>
                    </Col>

                    <MaterialTable
                      style={{ minHeight: "auto", width: "100%" }}
                      title=""
                      columns={[
                        { title: "Status", field: "status" },
                        {
                          title: "Vencimento",
                          field: "dataVencimento",
                          render: (rowData) =>
                            formateDateandTime(rowData.dataVencimento),
                        },
                        {
                          title: "Último Retorno",
                          field: "status",
                          render: (rowData) =>
                            rowData.logCobrancas &&
                              rowData.logCobrancas.length > 0
                              ? formateDateandTime(
                                rowData.logCobrancas[
                                  rowData.logCobrancas.length - 1
                                ].dataHora
                              )
                              : "",
                        },
                        {
                          title: "Retorno",
                          field: "status",
                          render: (rowData) =>
                            rowData.logCobrancas &&
                              rowData.logCobrancas.length > 0
                              ? rowData.logCobrancas[
                                rowData.logCobrancas.length - 1
                              ].retorno
                              : "",
                        },
                      ]}
                      data={requerimento.requerimentoCobrancas}
                      isLoading={false}
                      actions={[
                        {
                          icon: "insert_drive_file",
                          tooltip: "Visualizar",
                          onClick: (event, rowData) =>
                            openGuiaCobranca(rowData),
                        },
                      ]}
                      localization={table_translate}
                      options={table_style}
                    />
                  </Row>
                )}
              {historicoAnaliseGestor.length > 0 && (
                <Row className="mt-4">
                  <Col lg="12">
                    <h3 className="titulo-consulta">
                      Histórico de Análise Gestor
                    </h3>
                    <div className="line-protocolo"></div>
                  </Col>

                  <MaterialTable
                    style={{ minHeight: "auto", width: "100%" }}
                    title=""
                    columns={[
                      {
                        title: "Data Análise",
                        field: "dataAnalise",
                        render: (rowData) =>
                          formateDateandTime(rowData.dataAnalise),
                      },
                      { title: "Usuário", field: "usuarioAnalise_Nome" },
                      {
                        title: "Aprovado",
                        field: "aceite",
                        render: (rowData) => (rowData.aceite ? "Sim" : "Não"),
                      },
                      { title: "Observação", field: "observacao" },
                    ]}
                    data={historicoAnaliseGestor}
                    isLoading={false}
                    localization={table_translate}
                    options={table_style}
                  />
                </Row>
              )}

              {showAcoesGestor &&
                session != null &&
                session.tipoAcesso == "AreaRestrita" &&
                session.usuario_Id != null &&
                requerimento != null &&
                requerimento.status != "Finalizado" && (
                  <div className="mt-4">
                    <AcoesGestor
                      requerimento={requerimento}
                      handleReturn={handleReturn}
                    ></AcoesGestor>
                  </div>
                )}

              {(session == null ||
                (session && session.tipoAcesso == "Protocolo")) &&
                requerimento.status == "Pendente" &&
                requerimento.fluxoCadastroEtapaAtual != null &&
                requerimento.fluxoCadastroEtapaAtual.tipo ==
                "Emissão de Guia" &&
                setupSistema &&
                setupSistema.metodologiaCobranca == "Integração PRODAM" && (
                  <div className="text-center">
                    <Button
                      color="secondary"
                      onClick={() => {
                        if (
                          requerimento?.requerimentoCobrancas.filter(
                            (x) => x.status == "Pendente"
                          ).length > 0
                        ) {
                          showMessage(
                            "Aviso",
                            "Não é permitido emitir um novo boleto, pois você tem boletos pendentes.",
                            "warning",
                            null
                          );
                          return;
                        } else {
                          handleEmitirGuia();
                        }
                      }}
                      className="btn-mobile"
                      type="button"
                    >
                      Emitir Guia
                    </Button>
                  </div>
                )}
            </CardBody>
          </Card>
          <Modal
            centered
            isOpen={modalMapaOpen}
            toggle={() => set_modalMapaOpen(false)}
            zIndex="9999999"
          >
            <ModalBody className="md-bd">
              <h6>Localização no Mapa</h6>
              <Row className="mt-2">
                <Col lg="12">
                  <div id="map">
                    <MapContainer style={{ zIndex: "0" }}>
                      <ChangeMap center={centerMap} zoom={20}></ChangeMap>
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        opacity={0.5}
                      />
                      <Marker
                        position={positionMarker}
                        draggable={false}
                        icon={iconMarker}
                      ></Marker>
                    </MapContainer>
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className="md-ft">
              <Button
                color="secondary"
                outline
                onClick={() => set_modalMapaOpen(false)}
              >
                Fechar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
    </>
  );
}
